export default __webpack_public_path__ + "static/media/e.4e48b16b.svg";